<div class="w-full flex flex-col relative shadow-lg px-2 sm:px-7 action-bar-container" style="background: #fff">
  <div class="w-full flex responsive-height">
    <div class="flex w-3/12 justify-start items-center">
      <div class="flex flex-row items-center h-full cursor-pointer" routerLink="/" (click)="resetForm()">
        <img src="assets/Q_icon_color.png" class="h-9 w-9 md:h-9 lg:h-10 md:w-9 lg:w-10"
          style="width: 39.23px; height: 40px; object-fit: cover;" />
        <span class="flex ml-3 items-center h-full" id="service-lane-header-link"
          style="width: 133.4px; font-size: 24px; font-weight: 700; text-align: left;">
          <span class="flex items-center"
            style="width: 133.4px; height: 31px; font-size: 24px; font-weight: 700; text-align: left; color: #1c1c1c;">Power</span>
          <span class="flex items-center"
            style="width: 133.4px; height: 31px; font-size: 24px; font-weight: 700; text-align: left; color: #0054a6;">Lane</span>
        </span>
      </div>
    </div>
    <div *ngIf="employee && employee.jobTitleId != 'TCH'" class="flex w-5/12 justify-center items-center">
      <form class="hidden sm:flex"
        style="width: 90%; height: 46px; overflow: hidden; border-radius: 4px; background: #f3f4f6;"
        [formGroup]="vehicleSearchForm">
        <mat-form-field class="w-full inputSearch" id="inputSearch" appearance="none"
          style="display:flex; align-items: center; padding-top:15px; overflow:hidden; background: #f1f3f4;">
          <mat-icon matPrefix class="text-xl mr-1">search</mat-icon>
          <input id="search-input" type="text" #autoInput matInput formControlName="search" class="text-base"
            [matAutocomplete]="auto" placeholder="Search">
          <mat-autocomplete #auto="matAutocomplete" class="search-autocomplete-height search-autocomplete-width">
            <mat-progress-bar *ngIf="loadingSearchResults; else spacer" mode="indeterminate" class="w-full">
            </mat-progress-bar>
            <ng-template #spacer>
              <div class="w-48"></div>
            </ng-template>
            <mat-option class="w-full" (click)="selectVehicle(null); autoInput.value = '';autoInput.blur()">
              <mat-icon color="primary">add_circle</mat-icon>
              <span id="add-vehicle-link" class="mat-body-1 w-full">Add Vehicle</span>
            </mat-option>
            <mat-divider></mat-divider>


            <mat-optgroup id="appointments-option-group" label="Appointments">
              <mat-option
                *ngFor="let result of appointmentSearchResults | orderBy: '-appointmentDateTime';let i = index;"
                (click)="selectAppointment(result); autoInput.value = '';autoInput.blur()">
                <div class="flex flex-row place-content-start place-items-center">
                  <mat-icon class="mt-1.5 text-grey-500">event_note</mat-icon>
                  <div class="flex flex-col">
                    <span class="mat-body-1">
                      {{result.associateLastName + ', ' + result.associateFirstName}}</span>
                    <small class="mat-caption italic text-grey-500">
                      {{result.appointmentDateTime | date: 'EEEE, MMM. d, y @ h:mm a' }}
                    </small>
                  </div>
                </div>
              </mat-option>
            </mat-optgroup>

            <mat-optgroup id="vehicles-option-group" label="Vehicles">
              <mat-option *ngFor="let result of vehicleSearchResults | orderBy: '-year';let i = index;"
                (click)="selectVehicle(result); autoInput.value = '';autoInput.blur()">
                <div class="flex flex-row place-content-start place-items-center">
                  <mat-icon class="mt-1.5 text-grey-500">directions_car</mat-icon>
                  <div class="flex flex-col overflow-ellipsis">
                    <span class="mat-body-1">
                      {{result.year + ' ' + result.make + ' ' + result.model}}</span>
                    <small class="mat-caption italic text-grey-500">
                      {{'Owner: ' + result.associateLastName
                      + ', ' + result.associateFirstName +
                      ' · VIN: ' + result.vin + ' · Plate: ' + result.licensePlateNumber}}</small>
                  </div>
                </div>
              </mat-option>
            </mat-optgroup>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </div>
    <div class="flex justify-end items-center space-x-4"
      [ngClass]="(employee && employee.jobTitleId != 'TCH') ? 'w-4/12': 'w-3/4'">
      <div class="flex sm:hidden">
        <div *ngIf="!showMobileSearchBar" (click)="showMobileSearchBar = true" class="cursor-pointer">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.7812 13.8437C16.0625 14.1562 16.0625 14.6249 15.75 14.9062L14.875 15.7812C14.5938 16.0937 14.125 16.0937 13.8125 15.7812L10.7188 12.6874C10.5625 12.5312 10.5 12.3437 10.5 12.1562V11.6249C9.375 12.4999 8 12.9999 6.5 12.9999C2.90625 12.9999 0 10.0937 0 6.49994C0 2.93744 2.90625 -6.10352e-05 6.5 -6.10352e-05C10.0625 -6.10352e-05 13 2.93744 13 6.49994C13 8.03119 12.4688 9.40619 11.625 10.4999H12.125C12.3125 10.4999 12.5 10.5937 12.6562 10.7187L15.7812 13.8437ZM6.5 10.4999C8.6875 10.4999 10.5 8.71869 10.5 6.49994C10.5 4.31244 8.6875 2.49994 6.5 2.49994C4.28125 2.49994 2.5 4.31244 2.5 6.49994C2.5 8.71869 4.28125 10.4999 6.5 10.4999Z"
              fill="black" />
          </svg>
        </div>
      </div>
      <div class="flex items-center justify-center pl-2" id="noticeable-icon"></div>
      <mat-menu #avatarMenu="matMenu">
        <button id="logout-button" mat-menu-item (click)="logout()">Logout</button>
        <button id="settings-button" mat-menu-item (click)="openSettings()">
          {{ showSettings ? 'Close Settings' : 'Open Settings' }}
        </button>
      </mat-menu>
      <button preserveAspectRatio="none" id="avatar-icon" [matMenuTriggerFor]="avatarMenu">
        <div class="flex flex-row items-center">
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 7.99994C4.78125 7.99994 3 6.21869 3 3.99994C3 1.81244 4.78125 -6.10352e-05 7 -6.10352e-05C9.1875 -6.10352e-05 11 1.81244 11 3.99994C11 6.21869 9.1875 7.99994 7 7.99994ZM9.78125 8.99994C12.0938 8.99994 14 10.9062 14 13.2187V14.4999C14 15.3437 13.3125 15.9999 12.5 15.9999H1.5C0.65625 15.9999 0 15.3437 0 14.4999V13.2187C0 10.9062 1.875 8.99994 4.1875 8.99994H4.71875C5.40625 9.34369 6.1875 9.49994 7 9.49994C7.8125 9.49994 8.5625 9.34369 9.25 8.99994H9.78125Z"
              fill="black" />
          </svg>
          <span class="pl-4 pr-2 hidden sm:flex" style="font-size: 16px; color: #1c1c1c;">
            My Account
          </span>
        </div>
      </button>
    </div>
  </div>
  <div *ngIf="showMobileSearchBar" class="flex sm:hidden absolute pb-3 px-2 shadow-lg bg-white z-10 w-full left-0"
    style="top: 75px">
    <form class="w-full"
      style="height: 46px; overflow: hidden; border-radius: 4px; border: 1.5px solid #B6B8B9; background: #F8FAFC"
      [formGroup]="vehicleSearchForm">
      <mat-form-field class="w-full inputSearch" id="inputSearch" appearance="none"
        style="display:flex; align-items: center; padding-top:15px; overflow:hidden">
        <mat-icon matPrefix class="text-xl mr-1">search</mat-icon>
        <input id="search-input" type="text" #autoInput matInput formControlName="search" class="text-base"
          [matAutocomplete]="auto" placeholder="Search">
        <mat-autocomplete #auto="matAutocomplete" class="search-autocomplete-height search-autocomplete-width">
          <mat-progress-bar *ngIf="loadingSearchResults; else spacer" mode="indeterminate" class="w-full">
          </mat-progress-bar>
          <ng-template #spacer>
            <div class="w-48"></div>
          </ng-template>
          <mat-option class="w-full" (click)="selectVehicle(null); autoInput.value = '';autoInput.blur()">
            <mat-icon color="primary">add_circle</mat-icon>
            <span id="add-vehicle-link" class="mat-body-1 w-full">Add Vehicle</span>
          </mat-option>
          <mat-divider></mat-divider>


          <mat-optgroup id="appointments-option-group" label="Appointments">
            <mat-option *ngFor="let result of appointmentSearchResults | orderBy: '-appointmentDateTime';let i = index;"
              (click)="selectAppointment(result); autoInput.value = '';autoInput.blur()">
              <div class="flex flex-row place-content-start place-items-center">
                <mat-icon class="mt-1.5 from-grey-500">event_note</mat-icon>
                <div class="flex flex-col">
                  <span class="mat-body-1">
                    {{result.associateLastName + ', ' + result.associateFirstName}}</span>
                  <small class="mat-caption italic text-grey-500">
                    {{result.appointmentDateTime | date: 'EEEE, MMM. d, y @ h:mm a' }}
                  </small>
                </div>
              </div>
            </mat-option>
          </mat-optgroup>

          <mat-optgroup id="vehicles-option-group" label="Vehicles">
            <mat-option *ngFor="let result of vehicleSearchResults | orderBy: '-year';let i = index;"
              (click)="selectVehicle(result); autoInput.value = '';autoInput.blur()">
              <div class="flex flex-row place-content-start place-items-center">
                <mat-icon class="mt-1.5 bg-grey-500">directions_car</mat-icon>
                <div class="flex flex-col overflow-ellipsis">
                  <span class="mat-body-1">
                    {{result.year + ' ' + result.make + ' ' + result.model}}</span>
                  <small class="mat-caption italic text-grey-500">
                    {{'Owner: ' + result.associateLastName
                    + ', ' + result.associateFirstName +
                    ' · VIN: ' + result.vin + ' · Plate: ' + result.licensePlateNumber}}</small>
                </div>
              </div>
            </mat-option>
          </mat-optgroup>
        </mat-autocomplete>
        <div style="margin-bottom: 5px;" class="cursor-pointer" matSuffix (click)="showMobileSearchBar = false">
          <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.17188 7.5L9.51562 9.86719C9.82031 10.1484 9.82031 10.6172 9.51562 10.8984L9 11.4141C8.71875 11.7188 8.25 11.7188 7.96875 11.4141L5.625 9.07031L3.25781 11.4141C2.97656 11.7188 2.50781 11.7188 2.22656 11.4141L1.71094 10.8984C1.40625 10.6172 1.40625 10.1484 1.71094 9.86719L4.05469 7.5L1.71094 5.15625C1.40625 4.875 1.40625 4.40625 1.71094 4.125L2.22656 3.60938C2.50781 3.30469 2.97656 3.30469 3.25781 3.60938L5.625 5.95312L7.96875 3.60938C8.25 3.30469 8.71875 3.30469 9 3.60938L9.51562 4.125C9.82031 4.40625 9.82031 4.875 9.51562 5.15625L7.17188 7.5Z"
              fill="black" />
          </svg>
        </div>
      </mat-form-field>
    </form>
  </div>
</div>